// extracted by mini-css-extract-plugin
export default {"multiple_choice":"MultipleChoice_multiple_choice__DAWLp","unpressed":"MultipleChoice_unpressed__0YaRX","pressed":"MultipleChoice_pressed__KivVe"};